/**
 * @author Fernando Ruano
 * @file index.jsx
 * @description Initialize App hoc.
 */

// Components
import AppRoutes from '@nephro/components/AppRoutes';

// Routes
import routes from './routes';

const AppContainer = () => {
  return (
    <>
      <AppRoutes routes={routes} />
    </>
  );
};

export default AppContainer;
